import React from "react";
import { FaAngleRight } from "react-icons/fa";

export default function Button({icon, name, nextScreen}) {
  return (
    <div className="col-12 col-md-6 col-lg-4 d-flex">
    <div
      className="card card-body card-results text-dark mb-2"
      role="button"
      tabIndex="0"
      onClick={nextScreen}
      onKeyDown={(e) => e.target.onClick}
    >
      <div className="row justify-content-between mb-2">
        <div className="col">
          {icon}
        </div>
        <div className="col-auto">
          <FaAngleRight className="hire-results" />
        </div>
      </div>
      <p className="mt-auto mb-0">
        <strong>{name}</strong>
      </p>
    </div>
    </div>
  );
}
